import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useLocation, useNavigate, useParams} from "react-router";
import axios from "axios";
import {ErrorToaster, SuccessToaster} from "../../../shared/toaster";
import ModalHelper from "../../../components/fouladyar/modal-helper/modalHelper";
import {Field} from "../../../components/fouladyar/field/field";
import {useTranslation} from "react-i18next";

import ProfileImage from "../../../assets/images/mrpropfund/profile.png";
import BannerImage from "../../../assets/images/mrpropfund/image-01.jpg";
import {Button} from "reactstrap";
import {IoClose} from "react-icons/io5";
import ImageFileUpload from "../../../components/fouladyar/image-file-upload";
import {MdOutlineEditNote, MdPlaylistAddCheck, MdVerified} from "react-icons/md";
import {ConvertGregorianToJalali} from "../../../shared/convertGregorianToJalali";
import {toFarsiNumber} from "../../../shared/toFarsiNumber";
import {handleUpload} from "../../../shared/file/file";

const Profile = () => {
    const auth = useSelector((state) => state.auth);
    const {id} = useParams();
    const location = useLocation();

    const {t, i18n} = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const profileState = useSelector((state) => state.profile);
    const [isLoading, setIsLoading] = useState(true);
    const [orderId, setOrderId] = useState(true);
    const [modalComponent, setModalComponent] = useState(<div> empty </div>);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [cards, setCards] = useState([]);
    const [nationalCardImage, setNationalCardImage] = useState(null);
    const [selfiImage, setSelfiImage] = useState(null);

    const [profile, setProfile] = useState({
        _id: "",
        fullName: "",
        kycDetails: null,

    })

    const [kyc, setKyc] = useState({
        fullName: {
            key: 'نام نام خانوادگی',
            slug: 'fullName',
            value: '',
            status: '',
        },
        nationalCode: {
            key: 'کد ملی',
            slug: 'nationalCode',
            value: '',
            status: '',
        },
        birthDate: {
            key: 'تاریخ تولد',
            slug: 'birthDate',
            value: '',
            status: '',
        },
        adminDescription: {
            key: 'توضیحات تکمیلی ادمین',
            slug: 'admin-description',
            value: '',
            status: '',
        },
        userDescription: {
            key: 'توضیحات تکمیلی کاربر',
            slug: 'user-description',
            value: '',
            status: '',
        },
        nationalCardImage: {
            key: 'تصویر کارت ملی',
            slug: 'nationalCardImage',
            value: null,
            status: '',
        },
        selfiImage: {
            key: 'تصویر سلفی (به همراه کارت ملی)',
            slug: 'selfiImage',
            value: null,
            status: '',
        },

    });


    useEffect(() => {
        const url = new URL(window.location.href); // Get the full URL
        const orderId = url.searchParams.get("orderid"); // Extract 'orderid' parameter
        setOrderId(orderId || '')
        console.log("Order ID:", orderId);
        if (id) {
            getProfileByUserId()
        } else {

            getProfile();
        }
    }, []);

    async function getProfileByUserId() {
        try {
            setIsLoading(true)
            const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/user/profile/${id}`, {
                headers: {authorization: `Bearer ${auth.token}`}
            })

            console.log('cart', res.data)
            if (res.data.statusCode === 200 || !res.data.statusCode) {
                const user = res.data.data.user;
                if (user) {
                    setProfile(user)

                    if (user?.kycDetails?.extras) {
                        setKyc({
                            fullName: user?.kycDetails?.extras?.fullName || kyc.fullName,
                            nationalCode: user?.kycDetails?.extras?.nationalCode || kyc.nationalCode,
                            userDescription: user?.kycDetails?.extras?.userDescription || kyc.userDescription,
                            adminDescription: user?.kycDetails?.extras?.adminDescription || kyc.adminDescription,
                            birthDate: user?.kycDetails?.extras?.birthDate || kyc.birthDate,
                            nationalCardImage: user?.kycDetails?.extras?.nationalCardImage?.value ? user?.kycDetails?.extras?.nationalCardImage : kyc.nationalCardImage,
                            selfiImage: user?.kycDetails?.extras?.selfiImage.value ? user?.kycDetails?.extras?.selfiImage : kyc.selfiImage,
                        })
                    }
                }

            }
            setIsLoading(false)
        } catch (e) {
            ErrorToaster(e, t)
            setIsLoading(false)
        }
    }

    async function getProfile() {
        try {
            setIsLoading(true)
            const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/user`, {
                headers: {authorization: `Bearer ${auth.token}`}
            })

            console.log('cart', res.data)
            if (res.data.statusCode === 200 || !res.data.statusCode) {
                const user = res.data.data.user;
                if (user) {
                    setProfile(user)

                    if (user?.kycDetails?.extras) {
                        setKyc({
                            fullName: user?.kycDetails?.extras?.fullName || kyc.fullName,
                            nationalCode: user?.kycDetails?.extras?.nationalCode || kyc.nationalCode,
                            userDescription: user?.kycDetails?.extras?.userDescription || kyc.userDescription,
                            adminDescription: user?.kycDetails?.extras?.adminDescription || kyc.adminDescription,
                            birthDate: user?.kycDetails?.extras?.birthDate || kyc.birthDate,
                            nationalCardImage: user?.kycDetails?.extras?.nationalCardImage?.value ? user?.kycDetails?.extras?.nationalCardImage : kyc.nationalCardImage,
                            selfiImage: user?.kycDetails?.extras?.selfiImage.value ? user?.kycDetails?.extras?.selfiImage : kyc.selfiImage,
                        })
                    }
                }

            }
            setIsLoading(false)
        } catch (e) {
            ErrorToaster(e, t)
            setIsLoading(false)
        }
    }


    async function submit() {
        try {
            setIsLoading(true)


            let _nationalCardImage = undefined;
            let _selfiImage = undefined;


            if (nationalCardImage?.length > 0) {
                _nationalCardImage = await handleUpload(nationalCardImage[0]);
            }
            if (selfiImage?.length > 0) {
                _selfiImage = await handleUpload(selfiImage[0]);
            }
            console.log('_nationalCardImage', _nationalCardImage)
            console.log('_selfiImage', _selfiImage)


            //POST (New)
            if (!profile?.kycDetails?._id) {

                const res = await axios.post(`${process.env.REACT_APP_API_URL}/api/kyc`, {
                    ...kyc,
                    nationalCardImage: {
                        ...kyc.nationalCardImage,
                        _id: _nationalCardImage?.original?._id,
                        value: _nationalCardImage?.original?._id,
                    },
                    selfiImage: {
                        ...kyc.selfiImage,
                        _id: _selfiImage?.original?._id,
                        value: _selfiImage?.original?._id,
                    },
                }, {
                    headers: {authorization: `Bearer ${auth.token}`}
                })

                console.log('submit', res.data)
                if (res.data.statusCode === 200 || !res.data.statusCode) {
                    SuccessToaster({message: 'ثبت kyc با موفقیت انجام شد'}, t)
                    navigate('/dashboard')
                }
                setIsLoading(false)
            }
            //PUT (Update)
            else {
                const res = await axios.put(`${process.env.REACT_APP_API_URL}/api/kyc`, {
                    ...kyc,

                    nationalCardImage: {
                        ...kyc.nationalCardImage,
                        _id: _nationalCardImage ? _nationalCardImage?.original?._id : kyc.nationalCardImage?._id,
                        value: _nationalCardImage ? _nationalCardImage?.original?._id : kyc.nationalCardImage?._id,
                    },
                    selfiImage: {
                        ...kyc.selfiImage,
                        _id: _selfiImage ? _selfiImage?.original?._id : kyc.selfiImage?._id,
                        value: _selfiImage ? _selfiImage?.original?._id : kyc.selfiImage?._id,
                    },
                }, {
                    headers: {authorization: `Bearer ${auth.token}`}
                })

                console.log('submit', res.data)
                if (res.data.statusCode === 200 || !res.data.statusCode) {
                    SuccessToaster({message: 'ثبت kyc با موفقیت انجام شد'}, t)
                    navigate('/dashboard')

                }
                setIsLoading(false)
            }


        } catch (e) {
            ErrorToaster(e, t)
            setIsLoading(false)
        }
    }

    function setKYCValue(fieldName, e) {
        setKyc(prevState => {
            return {
                ...prevState,
                [fieldName]: {
                    ...kyc[fieldName],
                    value: e
                }
            }
        })
    }

    function KYCFiledItem({item, className, onStatusChange, noApprovalButtons}) {
        const [_value, setValue] = useState(item?.value)
        return (
            <div className={`kyc-container`}>
                <div className={`${noApprovalButtons ? "w-100" : "w-50"}`}>
                    {
                        <div className={`kyc-key-value-review ${className}`}>
                            <span>{item?.key}</span>
                            <span>{item?.value}</span>
                        </div>
                    }
                </div>
                {
                    !noApprovalButtons ?


                        <div className="d-flex flex-row w-50 kyc-image-actions-btn-cointainer">
                            {
                                !noApprovalButtons ? <>
                                    <button
                                        className={` kyc-normal-btn ${item.status === 'approved' ? 'disabled-btn' : ''} ${item.status === 'update_required' ? 'kyc-update-required-btn' : ''}`}
                                        type="button" onClick={() => {
                                        onStatusChange('update_required')
                                    }}>
                                        <MdOutlineEditNote size={17} color={"#fff"}/>
                                        نیاز به ویرایش
                                    </button>
                                    <button
                                        className={` kyc-normal-btn   ${item.status === 'update_required' ? 'disabled-btn' : ''} ${item.status === 'approved' ? 'kyc-approved-btn' : ''}`}
                                        type="button" onClick={() => {
                                        onStatusChange('approved')
                                    }}>
                                        <MdPlaylistAddCheck size={17} color={"#fff"}/>
                                        مورد قبول
                                    </button>
                                </> : ''
                            }
                        </div> : ''
                }
            </div>
        )
    }

    function KYCImageItem({item, onRemove, noApprovalButtons, onStatusChange}) {
        const [_value, setValue] = useState(item?.value)
        return (
            <div className="kyc-image-container admin">

                <div className="kyc-image-actions">
                    <h6>
                        {item?.key}
                    </h6>
                    <div className="d-flex flex-row w-100 kyc-image-actions-btn-cointainer">
                        {
                            !noApprovalButtons ? <>
                                <button
                                    className={` kyc-normal-btn ${item.status === 'approved' ? 'disabled-btn' : ''} ${item.status === 'update_required' ? 'kyc-update-required-btn' : ''}`}
                                    type="button" onClick={() => {
                                    onStatusChange('update_required')
                                }}>
                                    <MdOutlineEditNote size={17} color={"#fff"}/>
                                    نیاز به ویرایش
                                </button>
                                <button
                                    className={` kyc-normal-btn   ${item.status === 'update_required' ? 'disabled-btn' : ''} ${item.status === 'approved' ? 'kyc-approved-btn' : ''}`}
                                    type="button" onClick={() => {
                                    onStatusChange('approved')
                                }}>
                                    <MdPlaylistAddCheck size={17} color={"#fff"}/>
                                    مورد قبول
                                </button>
                            </> : ''
                        }
                    </div>
                </div>
                {
                    item?.value ?
                        <div className='form-field-input'>
                            <div className="remove-image-btn" onClick={() => {
                                onRemove()
                            }}>
                                <IoClose size={20} color={"#fff"}/>
                            </div>
                            <img src={`${process.env.REACT_APP_LIARA_STORAGE}/${item?.value}`} alt="post-image"/>
                        </div>
                        : ''
                }


            </div>
        )
    }

    function setKYCValue(fieldName, e) {
        setKyc(prevState => {
            return {
                ...prevState,
                [fieldName]: {
                    ...kyc[fieldName],
                    value: e
                }
            }
        })
    }

    function setKYCStatus(fieldName, e) {
            setKyc(prevState => {
                return {
                    ...prevState,
                    [fieldName]: {
                        ...kyc[fieldName],
                        status: e
                    }
                }
            })
        }




    async function approveKYC() {
        try {
            setIsLoading(true)
            const res = await axios.put(`${process.env.REACT_APP_API_URL}/api/kyc/status/approve`, {
                userId: id,
                extras: {
                    ...kyc,
                    nationalCardImage: {
                        ...kyc.nationalCardImage,
                        value: kyc.nationalCardImage?._id,
                    },
                    selfiImage: {
                        ...kyc.selfiImage,
                        value: kyc.selfiImage?._id,
                    },
                }
            },{
                headers: {authorization: `Bearer ${auth.token}`}
            })

            console.log('approveKYC', res.data)
            if (res.data.statusCode === 200 || !res.data.statusCode) {

                if(orderId)
                    navigate(`/order-detail/${orderId}`)
                else
                    navigate(`/app/ecommerce/order-list`)
                SuccessToaster({message: 'احراز هویت کاربر با موفقیت انجام شد'}, t)
            }
            setIsLoading(false)
        } catch (e) {
            ErrorToaster(e, t)
            setIsLoading(false)
        }
    }


    async function KYCNeedUpdate() {
        try {
            setIsLoading(true)
            const res = await axios.put(`${process.env.REACT_APP_API_URL}/api/kyc/status/kyc-need-update`, {
                userId: id,
                extras: {
                    ...kyc,
                    nationalCardImage: {
                        ...kyc.nationalCardImage,
                        value: kyc.nationalCardImage?._id,
                    },
                    selfiImage: {
                        ...kyc.selfiImage,
                        value: kyc.selfiImage?._id,
                    },
                }
            },{
                headers: {authorization: `Bearer ${auth.token}`}
            })

            console.log('approveKYC', res.data)
            if (res.data.statusCode === 200 || !res.data.statusCode) {
                if(orderId)
                    navigate(`/order-detail/${orderId}`)
                else
                    navigate(`/app/ecommerce/order-list`)

                SuccessToaster({message: 'اطلاعات احراز هویت با موفقیت بروز رسانی شد'}, t)
            }
            setIsLoading(false)
        } catch (e) {
            ErrorToaster(e, t)
            setIsLoading(false)
        }
    }




    return (
        <React.Fragment>
            <ModalHelper
                open={isModalOpen}
                onOpen={() => setIsModalOpen(true)}
                onClose={() => setIsModalOpen(false)}
                component={modalComponent}
            />

            <div className="nk-content ">
                <div className="container-fluid">

                    <div className="profile-info-container">
                        <div className="profile-image"><img src={ProfileImage} alt=""/></div>
                        <div className="profile-info">
                            <div
                                className="profile-name">{profile.fullName} {profile?.kycDetails?.status === 'approved' ?
                                <MdVerified size={20} color={"#4F9D81"}/> : ''} </div>
                            <div className="profile-description">
                                <div
                                    className={`kyc-status ${profile?.kycDetails?.status === 'pending' || profile?.kycDetails?.status === 'update_required' || !profile?.kycDetails?.status ? "yellow-color" : (profile?.kycDetails?.status === 'approved' ? "green-color" : "")}`}>
                                    {profile?.kycDetails?.status === 'pending' || !profile?.kycDetails?.status ? "حساب کاربری شما نیاز به احراز هویت دارد" : ""}
                                    {profile?.kycDetails?.status === 'approved' ? "احراز هویت شما با موفقیت انجام شده است" : ""}
                                    {profile?.kycDetails?.status === 'update_required' ? "اطلاعات احراز هویت شما نیاز به تغییرات دارد" : ""}
                                </div>
                            </div>
                        </div>
                    </div>


                    {
                        id ?
                            <div>

                                <h3 className={'yellow-color morabba-font'}>احراز هویت </h3>
                                <p className={'gray-color'}>
                                    لطفا در صورتی که اطلاعات وارد شده کاربر از قبیل نام و نام خانوادگی، کد ملی و تاریخ تولد مطابق
                                    اطلاعات درج شده بر روی کارت ملی شخص است، روی دکمه مورد تایید هر یک از موارد بزنید در غیر این صورت
                                    روی دکمه نیاز به اصلاح بزنید تا کاربر را به صورت دقیق مطلع کنیم که چه مواردی از احراز هویت مشکل دار
                                    است.
                                    <br/>
                                    <br/>
                                    پس از تکمیل فرم زیر در صورتی که دکمه (مورد تایید) از تمام موارد زده شده باشد، دکمه (تایید نهایی
                                    احراز هویت) فعال خواهد شد و شما میتوانید احراز هویت خود را تایید کنید.در غیر این صورت در فیلد
                                    توضیحات، توضیحات تکمیلی خود را در مورد مشکلاتی که اطلاعات و یا فایل ها داشته اند وارد کرده و در
                                    نهایت روی دکمه نیاز به اصلاح کلیک کنید.

                                    <br/>
                                </p>
                                <div className="kyc-image-container">
                                    <KYCFiledItem item={kyc.fullName} onStatusChange={(e) => {
                                        setKYCStatus('fullName', e)
                                    }}/>
                                    <KYCFiledItem item={{...kyc.nationalCode, value: toFarsiNumber(kyc.nationalCode.value)}}
                                                  onStatusChange={(e) => {
                                                      setKYCStatus('nationalCode', e)
                                                  }}/>
                                    <KYCFiledItem
                                        item={{...kyc.birthDate, value: toFarsiNumber(ConvertGregorianToJalali(kyc.birthDate.value))}}
                                        onStatusChange={(e) => {
                                            setKYCStatus('birthDate', e)
                                        }}/>
                                    <KYCFiledItem className="kyc-key-value-review-description" item={kyc.userDescription}
                                                  onStatusChange={(e) => {
                                                      setKYCStatus('userDescription', e)
                                                  }} noApprovalButtons={true}/>
                                </div>

                                <KYCImageItem item={kyc.nationalCardImage} onChange={(e) => {
                                    setKYCValue('nationalCardImage', e)
                                }} onStatusChange={(e) => {
                                    setKYCStatus('nationalCardImage', e)
                                }}/>
                                <KYCImageItem item={kyc.selfiImage} onChange={(e) => {
                                    setKYCValue('selfiImage', e)
                                }} onStatusChange={(e) => {
                                    setKYCStatus('selfiImage', e)
                                }}/>


                                <div className="kyc-image-container">
                                    <Field
                                        label={kyc?.adminDescription?.key}
                                        id={kyc?.adminDescription?.slug}
                                        name={kyc?.adminDescription?.key}
                                        type={"textarea"}
                                        value={kyc?.adminDescription?.value}
                                        onChange={(e) => {
                                            setKYCValue('adminDescription', e)
                                        }}
                                    />
                                </div>
                                <Button disabled={profile?.kycDetails?.status === 'approved'} className="green-button" size="md" type="submit" onClick={async () => {
                                    console.log(kyc)
                                    const requiredKeys = Object.keys(kyc).filter(key => {
                                        if(kyc[key].status !== 'approved' && key !== 'userDescription' && key !== "adminDescription"){
                                            return key;
                                        }
                                    });
                                    const notSelectedOneOrMore = Object.keys(kyc).filter(key => {
                                        if(kyc[key].status === '' && key !== 'userDescription' && key !== "adminDescription"){
                                            return key;
                                        }
                                    });
                                    console.log('requiredKeys', requiredKeys)

                                    if(notSelectedOneOrMore.length === 0){
                                        if(requiredKeys.length > 0){
                                            await KYCNeedUpdate()
                                            console.log('edit-required')
                                        }else{
                                            await approveKYC()
                                            console.log('all-approved')
                                        }
                                    }else{
                                        ErrorToaster({message: "لطفا وضعیت تمامی متغیر ها را انتخاب کنید"})
                                    }

                                }}>
                                    ثبت
                                </Button>
                            </div> :
                            <div>
                                <Field
                                    label={kyc.fullName?.key  + ( kyc.fullName?.status === 'update_required' ? ' (نیاز به تغییر) ': '')}
                                    id={kyc.fullName?.slug}
                                    name={kyc.fullName?.slug}
                                    type={"text"}
                                    value={kyc.fullName?.value}
                                    onChange={(e) => {
                                        setKYCValue('fullName', e)
                                    }}
                                />
                                <Field
                                    label={kyc.nationalCode?.key + ( kyc.nationalCode?.status === 'update_required' ? ' (نیاز به تغییر) ': '')}
                                    id={kyc.nationalCode?.slug}
                                    name={kyc.nationalCode?.slug}
                                    type={"text"}
                                    value={kyc.nationalCode?.value}
                                    onChange={(e) => {
                                        setKYCValue('nationalCode', e)
                                    }}
                                />
                                <Field
                                    label={kyc.birthDate?.key + ( kyc.birthDate?.status === 'update_required' ? ' (نیاز به تغییر) ': '')}
                                    id={kyc.birthDate?.slug}
                                    name={kyc.birthDate?.slug}
                                    isJalali={true}
                                    type={"date"}
                                    value={kyc.birthDate?.value}
                                    onChange={(e) => {
                                        setKYCValue('birthDate', e)
                                    }}
                                />
                                <Field
                                    label={kyc.userDescription?.key + ( kyc.userDescription?.status === 'update_required' ? ' (نیاز به تغییر) ': '')}
                                    id={kyc.userDescription?.slug}
                                    name={kyc.userDescription?.slug}
                                    isJalali={true}
                                    type={"textarea"}
                                    value={kyc.userDescription?.value}
                                    onChange={(e) => {
                                        setKYCValue('userDescription', e)
                                    }}
                                />


                                <div className="kyc-image-title">{kyc.nationalCardImage?.key + ( kyc.nationalCardImage?.status === 'update_required' ? ' (نیاز به تغییر) ': '')}</div>
                                <div className="kyc-image-container">
                                    {
                                        kyc.nationalCardImage?.value ?
                                            <div className='form-field-input'>
                                                <div className="remove-image-btn" onClick={() => {
                                                    // onRemove()
                                                }}>
                                                    <IoClose size={20} color={"#fff"}/>
                                                </div>
                                                <img
                                                    src={`${process.env.REACT_APP_LIARA_STORAGE}/${kyc.nationalCardImage?.value}`}
                                                    alt="post-image"/>
                                            </div>
                                            : ''
                                    }

                                    <div className=''>
                                        <ImageFileUpload
                                            onChange={(e) => {
                                                setNationalCardImage(e)

                                            }}
                                        />
                                    </div>
                                </div>


                                <div className="kyc-image-title">{kyc.selfiImage?.key + ( kyc.selfiImage?.status === 'update_required' ? ' (نیاز به تغییر) ': '')}</div>
                                <div className="kyc-image-container">
                                    {
                                        kyc.selfiImage?.value ?
                                            <div className='form-field-input'>
                                                <div className="remove-image-btn" onClick={() => {
                                                    // onRemove()
                                                }}>
                                                    <IoClose size={20} color={"#fff"}/>
                                                </div>
                                                <img
                                                    src={`${process.env.REACT_APP_LIARA_STORAGE}/${kyc.selfiImage?.value}`}
                                                    alt="post-image"/>
                                            </div>
                                            : ''
                                    }

                                    <div className=''>
                                        <ImageFileUpload
                                            onChange={(e) => {
                                                setSelfiImage(e)
                                            }}
                                        />
                                    </div>
                                </div>

                                <button disabled={isLoading} className="btn small-button green-bg-color" type="button" onClick={async () => {
                                    console.log('KYC Form', kyc)
                                    await submit()
                                }}>
                                    ثبت اطلاعات
                                </button>
                            </div>
                    }
                </div>
            </div>
        </React.Fragment>

    );
};

export default Profile;
